import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-node-status1",
  "use": "icon-node-status1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-node-status1\">\n<g id=\"icon-node-status1_icon\" clip-path=\"url(#icon-node-status1_clip0_346_35203)\">\n<path id=\"icon-node-status1_Vector\" d=\"M8 0.964844C4.11439 0.964844 0.964478 4.11461 0.964478 8.00007C0.964478 11.8855 4.11439 15.0353 8 15.0353C11.8856 15.0353 15.0355 11.8855 15.0355 8.00007C15.0355 4.11461 11.8856 0.964844 8 0.964844ZM11.0308 10.0039L10.0032 11.031L8.00035 9.0275L5.99642 11.031L4.96914 10.0039L6.97233 8.00009L4.96914 5.99658L5.99642 4.96915L8 6.97264L10.0032 4.96915L11.0308 5.99658L9.02728 8.00007L11.0308 10.0039Z\" fill=\"#C0C0C0\" />\n</g>\n<defs>\n<clipPath id=\"icon-node-status1_clip0_346_35203\">\n<rect width=\"16\" height=\"16\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/node-status1.svg
// module id = xB0d
// module chunks = 103